import React from 'react';
import AddReporteComponent from '../components/AddReporte'

import { sendFile } from '../../Services/service'

class AddReporte extends React.Component {
  state = {
    loading: false,
    texto: '',
    anualidad: '',
    value: '',
    fecha: null,
    textoError: false,
    anualidadError: false,
    valueError: false,
    fechaError: false,
    addFiles: []
  }

  handlerText = e => this.setState({ texto: e.target.value })
  selectAnualidad = e => this.setState({ anualidad: e.value })
  handlerValue = e => this.setState({ value: e.target.value })
  handlerDate = e => this.setState({ fecha: e.target.value })
  handlerFile = e => {
    let files = []
    for (let i = 0; i < this.state.addFiles.length; i++)
      files.push(new File([this.state.addFiles[i]], this.state.addFiles[i].name, { type: this.state.addFiles[i].type }))
    for (let i = 0; i < e.target.files.length; i++)
      files.push(new File([e.target.files[i]], e.target.files[i].name, { type: e.target.files[i].type }))
    this.setState({ addFiles: files })
  }
  fileSelect = () => document.getElementById('reporte-input-file').click()
  removeFile = file => {
    console.log(file)
    const files = this.state.addFiles.filter(f => f.name !== file)
    this.setState({ addFiles: files })
  }
  save = () => {
    this.setState({ loading: true })
    let data = new FormData()
    for (var x = 0; x < this.state.addFiles.length; x++) {
      data.append('files', this.state.addFiles[x])
    }
    data.append('texto', this.state.texto)
    data.append('fecha', this.state.fecha)
    data.append('value', Number(this.state.value))
    data.append('anualidad', parseInt(this.state.anualidad))
    data.append('pisccIndicadoreId', parseInt(this.props.indicador.id))
    const functions = { start: this.onStart, end: this.onEnd, onprogress: this.onProgress, error: this.onError }
    sendFile('/api/v1/piscc/uploadReporte', data, functions)
  }
  onStart = (e) => console.log('start', e)
  onEnd = (e) => {
    this.props.reload()
    this.setState({
      texto: '',
      anualidad: '',
      value: '',
      addFiles: [],
      loading: false
    })
  }
  onProgress = (e) => {
    if (e.lengthComputable) {
      console.log(e.loaded + " / " + e.total)
    }
  }
  onError = (e) => console.log('error', e)

  close = () => this.props.close()

  render() {
    return (
      <AddReporteComponent
        state={this.state}
        indicador={this.props.indicador}
        handlerText={this.handlerText}
        handlerValue={this.handlerValue}
        handlerDate={this.handlerDate}
        fileChange={this.handlerFile}
        selectAnualidad={this.selectAnualidad}
        fileSelect={this.fileSelect}
        removeFile={this.removeFile}
        save={this.save}
        close={this.close}
      />
    )
  }
}

export default AddReporte;